import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { avoid } from './shared/avoid'
import { videoLength } from './shared/videoLength'
import { promotion } from './shared/promotion'
import { callToAction } from './shared/callToAction'
import { language } from './shared/language'
import { TikTok } from 'almanac-ui/icons'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { TextChannels } from '../../../constants'

const meta = {
  type: ChannelType.TikTokScript,
  icon: TikTok,
  steps: ['Context', 'Generate Script'],
  title: TextChannels[ChannelType.TikTokScript].name,
  submitLabel: 'Generate Script',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183791/Home%20Card%20Previews/ws6t0mryoyigtm1yqexx.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic of your TikTok script?', generationType: meta.type }),
  video_length: videoLength
    .oneOf(['Less than 30 seconds', '30 to 60 seconds', 'More than 60 seconds'])
    .required()
    .default('30 to 60 seconds'),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  include_images: includeImages,
  tone,
  language,
  promotion: promotion.meta({ collapsible: true }),
  call_to_action: callToAction.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
}

export const TikTokScriptSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const TikTokScriptMultiStepSchema: MultiStepSchema<ChannelType.TikTokScript> = {
  steps: [
    TikTokScriptSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.TikTokScript,
    channel: ChannelType.TikTokScript,
  },
}
